var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cmpt-checkbox",class:{ checked: _vm.modelValue, disabled: _vm.disabled },on:{"click":function($event){return _vm.$emit('update:modelValue', !_vm.modelValue)}}},[_c('div',{staticClass:"checkmark-box"},[_c('div',{staticClass:"checkmark"},[_c('img',{staticClass:"checkmark-icon",attrs:{"src":_vm.toggleBase64,"alt":""}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }